import * as React from 'react';
import highcharts, { Options as HighchartOptions, Chart } from 'highcharts';
import HC_drilldown from 'highcharts/modules/drilldown';
import HC_exporting from 'highcharts/modules/exporting';
import HC_offline_exporting from 'highcharts/modules/offline-exporting';
import highChartsMore from 'highcharts/highcharts-more';
import { ChartType } from '../../Features/Delsystem/Ekonomi/Rutiner/EkonomiskAnalys/Queries/EkonomiskAnalysChartQuery/EkonomiskAnalysChartQuery';
import robotoBase64 from './Utils/RobotoBase64';

highChartsMore(highcharts);
HC_drilldown(highcharts);
HC_exporting(highcharts);
HC_offline_exporting(highcharts);

// Embedda Roboto Regular i SVG, för att den alltid ska kunna läsas vid export till PNG
highcharts.wrap(
  highcharts,
  'downloadSVGLocal',
  (p: any, svg: any, options: any) => {
    const s = svg.replace(
      /<\/svg/,
      `<style>@font-face {font-family: "Roboto";src:url(data:application/font-woff;charset=utf-8;base64,${robotoBase64};}</style>$&`
    );
    p(s, options);
  }
);

export interface IOptions extends HighchartOptions {}
interface IProps {
  type?: ChartType;
  options: IOptions;
  afterChartCreated?: (chart: Chart) => void;
}

class EDHighchartsWrapper extends React.Component<IProps> {
  chart!: Chart;
  container!: HTMLElement;

  componentDidMount() {
    this.chart = highcharts.chart(this.container, this.getChartOptions());
    if (this.props.afterChartCreated) {
      this.props.afterChartCreated(this.chart);
    }
  }

  componentDidUpdate() {
    this.chart.update(this.getChartOptions());
  }

  componentWillUnmount() {
    this.chart.destroy();
  }

  getChartOptions = (): IOptions => {
    let options = this.props.options;

    if (!options.chart) {
      options.chart = {
        style: {
          fontFamily: 'Roboto',
        },
      };
    } else {
      options.chart.style = {
        fontFamily: 'Roboto',
      };
    }

    if (this.props.type) {
      options.chart.type = this.props.type;
    }

    options.exporting = {
      fallbackToExportServer: false,
      enabled: false,
    };

    return options;
  };

  ref = (container: any) => {
    this.container = container;
  };

  render() {
    return <div ref={this.ref} />;
  }
}

export default EDHighchartsWrapper;
